const MAX_DIMENSION = 1280
const JPEG_QUALITY = 0.82

const canvasToJpegFile = (canvas: HTMLCanvasElement, fileName: string): Promise<File> => {
    return new Promise((resolve, reject) => {
        canvas.toBlob(
            (blob) => {
                if (!blob) {
                    reject(new Error('Failed to compress image'))
                    return
                }
                const name = fileName.replace(/\.[^.]+$/, '') + '.jpg'
                resolve(new File([blob], name, { type: 'image/jpeg' }))
            },
            'image/jpeg',
            JPEG_QUALITY,
        )
    })
}

export const compressImageFile = async (file: File): Promise<File> => {
    const bitmap = await createImageBitmap(file)
    const scale = Math.min(1, MAX_DIMENSION / Math.max(bitmap.width, bitmap.height))
    const width = Math.max(1, Math.round(bitmap.width * scale))
    const height = Math.max(1, Math.round(bitmap.height * scale))
    const canvas = document.createElement('canvas')
    canvas.width = width
    canvas.height = height
    const context = canvas.getContext('2d')
    if (!context) {
        bitmap.close()
        return file
    }
    context.drawImage(bitmap, 0, 0, width, height)
    bitmap.close()
    return canvasToJpegFile(canvas, file.name)
}

export const compressImageFiles = async (files: File[]): Promise<File[]> => {
    return Promise.all(files.map((file) => compressImageFile(file)))
}
